import { Flex, Menu, MenuButton, MenuList, Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'utils/GlobalHelpers';
import AddToDashboard from 'components/Icons/AddToDashboard';
import { getSelectedPage, prepareCreatePayload } from 'redux/DashboardSliceV2';

import InstrumentMenuList from './InstrumentMenuList';

const EmptyDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const selectedPage = useSelector(getSelectedPage);

  const onSelectInstrument = (widgetType: string) => dispatch(prepareCreatePayload(widgetType));

  return (
    <Flex
      flexDirection={'column'}
      mt={4}
      width={'100%'}
      maxW={'400px'}
      height={'250px'}
      bg={'white'}
      color={'#787878'}
      borderRadius={'15px'}
      justifyContent={'space-around'}
      alignItems={'center'}
      p={6}
    >
      <Menu variant={'dashboarding'}>
        {({ isOpen }) => {
          return (
            <>
              <MenuButton
                disabled={!selectedPage}
                title={selectedPage ? 'Create Instrument' : 'Please create page'}
              >
                <AddToDashboard width={100} height={100} />
              </MenuButton>
              {isOpen && (
                <MenuList>
                  <InstrumentMenuList onSelectInstrument={onSelectInstrument} />
                </MenuList>
              )}
            </>
          );
        }}
      </Menu>
      <Text size='addToDashboard'>Add to dashboard</Text>
    </Flex>
  );
};

export default EmptyDashboard;
